module.exports = __webpack_public_path__ + "img/caelex.7851dc76.png";